import { Component, ElementRef, OnInit, ViewChild, Inject } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestService } from '../services/request.service';
import { ProductService } from '../services/product.service';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith, filter } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent, MatAutocomplete, MatDialog, MatDialogRef, MAT_DIALOG_DATA, DateAdapter, MatSnackBar, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatTableDataSource } from '@angular/material';
import { ClientService } from '../services/client.service';
import { DocumentService } from '../services/document.service';
import { ActionsService } from '../services/actions.service';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import { MY_FORMATS, IndicatorData, IndicatorModal, ClientModal } from '../request-insert/request-insert.component';

export interface ArchiveRequest {
  name: string;
  result: string;
}

@Component({
  selector: 'app-archive-request',
  templateUrl: './archive-request.component.html',
  styleUrls: ['./archive-request.component.css'],
  providers:[
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class ArchiveRequestComponent implements OnInit {
  id: number;
  clients: any;
  products: any;
  subProducts: any;
  subSubProducts: any;
  client_name: string;
  client_id: any;
  product_id: number;
  subProduct_id: number;
  subSubProduct_id: number;
  sort: string;
  batch: string;
  vintage: any;
  subShow: boolean;
  subSubShow: boolean;
  quantity: number;
  indicators: any;
  price_all: number;
  checked_indicators: any;
  created_at: any;
  object = [];
  myControl = new FormControl();
  filteredOptions: Observable<any>;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;


  showTable = false;
  result: string;



  separatorKeysCodes: number[] = [ENTER, COMMA];
  fruitCtrl = new FormControl();
  filteredFruits: Observable<any>; // filtered indicators
  selIndicators: any = []; //selected indicators
  allIndicators: any = [];
  selIndicatorIds: any = [];
  selectedClient: any = [];
  modalIndicators: any = [];
  batch_quantity:string;
  columnsToDisplay: any;
  displayedColumns: any;
  dataSource: any;
  selection: any;

  matForm: any;
  maxDate: any = new Date(); // max vintage date
  token:string = localStorage.getItem('token');

  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor(private requestService: RequestService,
    private productService: ProductService,
    private actionService: ActionsService,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar,
    public clientService: ClientService,
    private documentService: DocumentService,
    private dateAdapter: DateAdapter<Date>,
    public dialog: MatDialog) {
    this.getClients();
    this.getProducts();
    dateAdapter.setLocale('en-in');
  }

  public loading = false;

  ngOnInit() {
  }


  chosenYearHandler(event) {
    var year = event._i.year;
    console.log(event,event._i.year,'mina');
    this.vintage = new Date(year+'-01-01');
    // picker.close();
  }




  //modal
  openDialog(): void {
    const dialogRef = this.dialog.open(ClientModal, {
      width: '600px',
      data: {
        contract: 0,
        discount: '',
        dds: 1
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.clientService.saveClient(result).subscribe(data => {
          this.clientSelected(result.name + " - " + result.eik);
          this.client_name = result.name + " - " + result.eik;
        });
      }


    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }


  private _filter(value: string): string[] {
    if (value != null) {
      const filterValue = value.toLowerCase();
      return this.clients.filter(clients => clients.toLowerCase().includes(filterValue));
    }
  }

  clientSelected(name) {
    if (name != null) {
      this.requestService.clientInfo(name).subscribe(data => {
        this.client_name = name;
        this.selectedClient = data;

      });
    }

  }



  getClients() {
    this.requestService.getClients().subscribe(data => {
      this.clients = data;
      this.filteredOptions = this.myControl.valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        );
    });

    return this.clients;
  }



  getProducts() {
    this.productService.getProducts().subscribe(data => {
      this.products = data;
      this.product_id = 0;
    });

    return this.products;
  }

  getSubProds(id) {
    const routeId = +this.route.snapshot.paramMap.get('id');
    this.productService.getSubProducts(id).subscribe(data => {
      this.subProducts = data;
      // this.selIndicatorIds = [];
      // this.selIndicators = [];//tuka
      if (routeId == 0) {
        this.subProduct_id = 0;
      }
      if (id != 0) {
        this.getIndicators(id);
        this.subShow = true;
        this.subSubShow = false;
      } else {
        this.subShow = false;
        this.subSubShow = false;
      }
    });
  }

  getSubSubProds(id) {
    const routeId = +this.route.snapshot.paramMap.get('id');
    this.productService.getSubProducts(id).subscribe(data => {
      this.subSubProducts = data;
      if (this.subSubProducts.length > 0) {
        if (routeId == 0) {
          this.subSubProduct_id = 0;
        }

        if (id != 0) {
          // this.getIndicators(id);
          this.subSubShow = true;
        } else {
          // this.getIndicators(this.product_id);
          this.subSubShow = false;
        }
      }

    });
  }



  getIndicators(id) {
    this.productService.getIndicators(id).subscribe(data => {
      this.indicators = data;
      this.allIndicators = data;
      // this.selIndicators.forEach(element => {
      //   console.log(this.allIndicators.indexOf(element));
      // });
      // this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
      //   startWith(null),
      //   map((fruit: string | null) => fruit ? this._filterChip(fruit) : this.allIndicators.slice())
      // );

    });

  }



  generateTable(){
    console.log('mina');
    this.displayedColumns = ['name', 'result' ];
    this.columnsToDisplay = this.displayedColumns.slice();
    this.dataSource = new MatTableDataSource<ArchiveRequest>(this.selIndicators);
    this.showTable = true;
  }


  //indicators modal

  openIndicatorDialog(): void {
    if(this.product_id != 0){
      this.requestService.getModalIndicators(this.product_id).subscribe(data1 => {
        console.log(data1);
        this.requestService.setModalIndicators(this.selIndicators);
        const dialogRef = this.dialog.open(IndicatorModal, {
          data: { indicators: data1, selectedIds: this.selIndicatorIds != undefined ? this.selIndicatorIds : [], fruitCtrl: this.fruitCtrl },
        });
  
        dialogRef.afterClosed().subscribe(result => {
          this.selIndicators = this.requestService.modalIndicatorsGet();
          console.log(this.selIndicators);
          if(this.selIndicators.length > 0){
            this.generateTable();
          }
          this.selIndicatorIds = this.requestService.getIndicatorsIds();
        });
      });
    }else{
      this.openSnackBar('Изберете категория',null);
    }
    

  }


}


